var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudiAIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28713_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4737 32C6.24105 32 2 36.2528 2 41.5V51H11.4737V32Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9473 41.5C20.9473 46.7472 16.7063 51 11.4736 51H30.421V47.7953C27.6578 44.3278 25.9999 39.9388 25.9999 35.1667C25.9999 26.053 32.0315 18.3263 40.3021 15.7867C37.4252 14.0197 34.0399 13 30.421 13C19.9557 13 11.4736 21.5057 11.4736 32C16.7063 32 20.9473 36.2528 20.9473 41.5Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9473 41.5C20.9473 36.2528 16.7063 32 11.4736 32V51C16.7063 51 20.9473 46.7472 20.9473 41.5Z",
    fill: "#F35F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3685 32.0002C49.3685 39.5147 45.017 46.0095 38.7012 49.0938C40.937 50.3098 43.4949 51.0002 46.2106 51.0002C54.9296 51.0002 62.0001 43.91 62.0001 35.1668C62.0001 26.4237 54.9296 19.3335 46.2106 19.3335C45.6706 19.3335 45.137 19.362 44.6096 19.4158C47.5685 22.7693 49.3685 27.1742 49.3685 32.0002Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4209 51.0002H33.6167C33.522 50.9242 33.4272 50.8514 33.3356 50.7754C32.3851 50.9211 31.4125 51.0002 30.4209 51.0002Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4209 47.7954V51.0001C31.4125 51.0001 32.3851 50.9241 33.3356 50.7752C32.2651 49.8854 31.2893 48.8847 30.4209 47.7954Z",
    fill: "#F38221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6093 19.4155C36.6419 20.2199 30.4209 26.9649 30.4209 35.1697C30.4209 41.1769 33.7746 46.4114 38.7009 49.0967C45.0135 46.0155 49.3683 39.5207 49.3683 32.003C49.3683 27.1739 47.5683 22.769 44.6093 19.4187V19.4155Z",
    fill: "#F38221"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28713_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38,
    fill: "white",
    transform: "translate(2 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudiAIcon);
export default __webpack_public_path__ + "static/media/CloudiA_icon.317df0db74ac5967f13c8e487f67568c.svg";
export { ForwardRef as ReactComponent };